import { usePathname } from 'next/navigation';

import { checkIsAdminPanel, checkIsClientsPanel, checkIsPlatform } from '~/shared/helpers/check-helpers';

const useAdditionalMenu = () => {
  const pathname = usePathname();
  const isAdminPanel = checkIsAdminPanel(pathname);
  const isPlatform = checkIsPlatform(pathname);
  const isClientsPanel = checkIsClientsPanel(pathname);

  return {
    isAdminPanel,
    isPlatform,
    isClientsPanel,
  };
};

export default useAdditionalMenu;
